export enum Protocol {
  HTTP = 'http',
  WS = 'ws'
}
